import { Action, createAction, handleActions } from 'redux-actions'

export interface IReadOnlyState {
  readonly: boolean
}

export const SCHEDULEPAYMENT_READONLY = 'schedulePaymentReadOnly'

const READONLY = `${SCHEDULEPAYMENT_READONLY}/readonly`
const ABLED = `${SCHEDULEPAYMENT_READONLY}/abled`

export const readOnlyActions = {
  readOnly: createAction(READONLY),
  abled: createAction(ABLED),
}

const initialState = {
  readonly: false,
}

export const reducer = {
  [READONLY]: (state: IReadOnlyState, action: Action<string>) => ({
    ...state,
    readonly: true,
  }),
  [ABLED]: (state: IReadOnlyState, action: Action<string>) => ({
    ...state,
    readonly: false,
  }),
}

export const schedulePaymentReadOnlyReducer = handleActions(reducer, initialState)
